module.exports = __webpack_public_path__ + "img/YouPlusZH-7.08db4de6.jpg";